import { styled } from 'libs/ui/styled';

export const ContactTypeFieldWrapper = styled('div')({
  width: '240px',
});
